import { defineStore } from 'pinia'
import { ref } from 'vue'

import { useFetchStore } from '@/stores/fetch'
import { isAdmin } from '@/libs/auth'
import type { INotification } from '@/types/Notification'
import type { IPendingReservation } from '@/types/Reservation'

export const useNotificationStore = defineStore('notification', () => {
    const unread = ref(0)
    const pending = ref(0)

    const refreshUnread = async () => {
        const fetchStore = useFetchStore()
        const { statusCode, data } = await fetchStore.fetch('/notifications').get().json<INotification[]>()
        if (statusCode.value === 200 && data.value) {
            unread.value = data.value.filter((n) => !n.read).length
        }
    }

    // Pending confirmations count for the "Potrditve" nav badge (SA+PA only).
    const refreshPending = async () => {
        if (!isAdmin()) { pending.value = 0; return }
        const fetchStore = useFetchStore()
        const { statusCode, data } = await fetchStore.fetch('/reservations/pending').get().json<IPendingReservation[]>()
        if (statusCode.value === 200 && data.value) {
            pending.value = data.value.length
        }
    }

    return { unread, pending, refreshUnread, refreshPending }
})
